module.exports = __webpack_public_path__ + "img/02-thumb.0f96eb31.jpg";